import { useEffect } from 'react';

import { Analytics } from '@setvi/shared/enums';
import type { Resource } from '@setvi/shared/interfaces';

import { endActivity, startActivity } from './buffer';

/**
 * Times how long a resource stays open and reports it as one RESOURCE_VIEWED
 * row. Call it from the component that exists exactly while the resource is on
 * screen — mounting starts the clock, unmounting ends it.
 *
 * `resourceId` is the `ResourceID` string, not the numeric `ID`: analytics
 * keeps it in `ParentObjectID`, which holds the ResourceID.
 *
 * The row is buffered rather than posted immediately, so closing several
 * resources in a row costs one request instead of one each.
 */
export const useResourceViewActivity = (
  resourceId?: Resource['ResourceID']
) => {
  useEffect(() => {
    if (!resourceId) return undefined;

    const viewId = startActivity(resourceId, Analytics.ResourceViewed);
    return () => endActivity(viewId);
  }, [resourceId]);
};
